
(function() {
  'use strict';
  function initConditionalBlocks() {
    const mobileMenu = document.querySelector('mobile-menu');
    if (!mobileMenu) {
      return;
    }
    const conditionalBlocks = mobileMenu.querySelectorAll('[data-show-for-menu]');
    const indexOnlyBlocks = mobileMenu.querySelectorAll('[data-show-only-on-index]');

    if (conditionalBlocks.length === 0 && indexOnlyBlocks.length === 0) {
      return;
    }
    conditionalBlocks.forEach((block) => {
      block.style.display = 'none';
      block.setAttribute('data-conditional-hidden', 'true');
    });
    indexOnlyBlocks.forEach((block) => {
      block.style.removeProperty('display');
      block.setAttribute('data-index-only-hidden', 'false');
    });
    function isOnMainMenu() {
      const visiblePanels = mobileMenu.querySelectorAll('.sliderule__panel.is-visible');
      return visiblePanels.length === 0 || (visiblePanels.length === 1 && visiblePanels[0].getAttribute('data-sliderule-pane') === '0');
    }
    function updateIndexOnlyBlocks() {
      const showBlocks = isOnMainMenu();
      indexOnlyBlocks.forEach(block => {
        if (showBlocks) {
          block.style.removeProperty('display');
          block.setAttribute('data-index-only-hidden', 'false');
        } else {
          block.style.display = 'none';
          block.setAttribute('data-index-only-hidden', 'true');
        }
      });
    }
    function getActiveMenuHandles() {
      const handles = [];
      const visiblePanels = mobileMenu.querySelectorAll('.sliderule__panel.is-visible');
      visiblePanels.forEach(panel => {
        const titleElement = panel.querySelector('.sliderow--back .sliderow__title');
        if (titleElement && titleElement.tagName === 'A' && titleElement.href) {
          const url = new URL(titleElement.href);
          const pathname = url.pathname;
          const handle = pathname.split('/').filter(Boolean).pop();
          if (handle) {
            handles.push(handle);
          }
        }
      });
      return handles;
    }
    function updateBlockVisibility() {
      const activeHandles = getActiveMenuHandles();
      conditionalBlocks.forEach(block => {
        const showForHandle = block.getAttribute('data-show-for-menu');
        if (activeHandles.length === 0 || !activeHandles.includes(showForHandle)) {
          block.style.display = 'none';
          block.setAttribute('data-conditional-hidden', 'true');
        } else {
          block.style.removeProperty('display');
          block.setAttribute('data-conditional-hidden', 'false');
        }
      });
      updateIndexOnlyBlocks();
    }
    mobileMenu.addEventListener('click', (e) => {
      const slideruleButton = e.target.closest('[data-sliderule-open]');
      const closeButton = e.target.closest('[data-sliderule-close]');
      const drawerClose = e.target.closest('[data-drawer-close]');
      if (slideruleButton || closeButton) {
        setTimeout(updateBlockVisibility, 150);
      } else if (drawerClose) {
        setTimeout(() => {
          conditionalBlocks.forEach(block => {
            block.style.display = 'none';
            block.setAttribute('data-conditional-hidden', 'true');
          });
          indexOnlyBlocks.forEach(block => {
            block.style.removeProperty('display');
            block.setAttribute('data-index-only-hidden', 'false');
          });
        }, 150);
      }
    });

    const observer = new MutationObserver((mutations) => {
      const hasVisibilityChange = mutations.some(mutation => {
        return mutation.type === 'attributes' &&
               mutation.target.classList &&
               mutation.target.classList.contains('sliderule__panel');
      });

      if (hasVisibilityChange) {
        updateBlockVisibility();
      }
    });

    observer.observe(mobileMenu, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });

    updateBlockVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConditionalBlocks);
  } else {
    initConditionalBlocks();
  }

})();
